module.exports = __webpack_public_path__ + "d0da41e1e8fe7beaeafbec84279e2441.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/linkCard/daily.jpg
// module id = Px7a
// module chunks = 0